import { materialsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";
export const conf = defineEntity({
  ...entityFactory("materials"), // Changed from 'service-task-causes'
  endpoint: "materials", // Changed from 'service-task-causes'
  operations: materialsOps,
  roleView: [ROLE.SC_TASK_CATEGORY_VIEW, ROLE.SC_TASK_CATEGORY_ADMIN],
  roleAdmin: [ROLE.SC_TASK_CATEGORY_ADMIN],
  singularName: (t) => t("Material"), // Changed from 'Service task cause'
  name: (t) => t("Materials"), // Changed from 'Service task causes'
  syncCustomerFilter: true,
  dependencies: ["service-task"],
});
export default conf;
